<button 
  mat-raised-button 
  [color]="'primary'" 
  (click)="onClick()"
  type="button"
  [disabled]="disabled || loading"
  class="h-11 px-8">
  
  @if (loading) {
    <div class="flex items-center gap-2">
      <app-loading-spinner-fuse [diameter]="20" [centered]="false"></app-loading-spinner-fuse>
      <span translate>{{ buttonText | translate }}</span>
    </div>
  } @else {
    @if (mode !== 'lilate') {
      <span translate>feature.ponctual-schedule.Réserver </span>
    }
    <span translate>{{ buttonText | translate }}</span>
  }
</button>
